import React, { FC } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Alert, Button } from '@mui/material';

import DevOverrides from 'src/utils/DevOverrides';

import { enviromentConfig } from 'src/config';

export const LocalhostBanner: FC = () => {
  const { t } = useTranslation();
  const isDevelopment = enviromentConfig.environment !== 'production';
  const isLocal = !!DevOverrides.getLocalBackendUrl();

  const handleRemoveLocalBackend = () => {
    DevOverrides.removeLocalBackendUrl();
    window.location.reload();
  };

  if (!isLocal || !isDevelopment) {
    return null;
  }

  return (
    <Alert
      sx={{
        borderRadius: 0,
      }}
      severity="warning"
      action={
        <Button size="small" onClick={handleRemoveLocalBackend}>
          {t('hiring-dashboard-common:common.localhostBanner.reset')}
        </Button>
      }
    >
      {t('hiring-dashboard-common:common.localhostBanner.connectedToLocalBackend')}
    </Alert>
  );
};
